import { StaticQuery, graphql } from "gatsby"
import React, { useState, useEffect } from "react"
import { useCurrentWidth } from "react-socks"

import PriceSwitch from "./priceSwitch"
import { breakpoints } from "../../utils/styleVariables"
import { TableSelect } from "./tableSelect"

const RenderComponent = ({ data }) => {
  const [priceVariation, setPrice] = useState(0)
  const [isDesktop, setIsDeskop] = useState(true)
  const currentWidth = useCurrentWidth()

  useEffect(() => {
    setIsDeskop(currentWidth > breakpoints.tablet)
  }, [currentWidth])

  const { yaml, images } = data
  const {
    planData,
    mainFeatures,
    moreFeatures,
    moreFeaturesCopy,
    moreMobileCopy,
    switchLabels,
    switchParams,
    switchText,
    linkBase,
  } = yaml.content

  const imagesEnum = {}

  images.nodes.forEach(image => {
    const name = image.image.fluid.originalName.split(".")[0]
    imagesEnum[name] = image.image
  })

  const handleSwitch = value => {
    setPrice(value)
  }

  return (
    <div>
      {switchLabels.length > 1 && (
        <PriceSwitch
          labels={switchLabels}
          switchText={switchText}
          handleSwitch={handleSwitch}
        />
      )}
      <TableSelect
        isDesktop={isDesktop}
        plans={planData}
        features={[mainFeatures, moreFeatures]}
        price={priceVariation}
        periods={switchLabels}
        periodParams={switchParams}
        link={linkBase}
        moreCopy={moreFeaturesCopy}
        moreMobile={moreMobileCopy}
      />
    </div>
  )
}

const PricingTable = () => (
  <StaticQuery
    query={graphql`
      {
        yaml: contentYaml(header: { slug: { eq: "/pricing" } }) {
          content {
            planData {
              description
              price
              discount
              slug
              storage
              sub
              title
              services {
                blog
                products
                gateway
                freeDomain
                discountCode
                pageBuilder
                menuBuilder
                advancedSearch
                telegramBot
                sslCrt
                sslCert
                accounting
                shipping
                moreSales
                reporting
                easySeo
                supportChat
                foreignPayment
                zoomableImage
                freePromotion
                advancedFilters
                advancedReport
                salesGoal
                freeConsult
                smsNotif
                emailNotif
                ganalytics
                gtagmanager
                marketingAgency
                torobIntegration
                pakatIntegration
                buyerReport
                salesReport
                orderReport
                freeShipping
                productVideo
                descriptionImage
              }
              button {
                text
                to
                icon
              }
            }
            moreFeaturesCopy
            moreMobileCopy
            mainFeatures {
              blog
              products
              gateway
              freeDomain
              discountCode
              pageBuilder
              menuBuilder
              advancedSearch
              telegramBot
              sslCert
            }
            moreFeatures {
              accounting
              shipping
              moreSales
              reporting
              easySeo
              supportChat
              foreignPayment
              zoomableImage
              freePromotion
              advancedFilters
              advancedReport
              salesGoal
              freeConsult
              smsNotif
              emailNotif
              ganalytics
              gtagmanager
              marketingAgency
              torobIntegration
              pakatIntegration
              buyerReport
              salesReport
              orderReport
              freeShipping
              productVideo
              descriptionImage
            }
            switchLabels
            switchParams
            switchText
            linkBase
          }
        }
        images: allFile(filter: { relativePath: { regex: "/plans/" } }) {
          nodes {
            image: childImageSharp {
              fluid {
                originalName
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    `}
    render={data => <RenderComponent data={data} />}
  />
)

export default PricingTable
